import { BaseIcon, ButtonProps } from "@shltelemedicine/shl-ui-lib";
import { Button } from "@shltelemedicine/shl-ui-lib";
import editIcon from "../../../assets/shared/edit.svg";
import styles from "./EditButton.module.css";

const EditButton = ({ className, ...rest }: ButtonProps) => {
  return (
    <Button className={`${styles.button} ${className ?? ""}`} {...rest}>
      <BaseIcon icon={editIcon} className={styles.icon} />
    </Button>
  );
};

export default EditButton;
